(()=>{
function init(root){
 if(root.dataset.ready)return;root.dataset.ready='1';
 const currency=root.dataset.currency||'USD',locale=root.dataset.locale||'en';
 const fmt=new Intl.NumberFormat(locale,{style:'currency',currency,currencyDisplay:'narrowSymbol'});
 const parts=new Intl.NumberFormat(locale).formatToParts(12345.6),dec=parts.find(p=>p.type==='decimal')?.value||'.',grp=parts.find(p=>p.type==='group')?.value;
 const num=s=>{let x=(s||'').replaceAll('\u00a0','').replaceAll('\u202f','');if(grp)x=x.split(grp).join('');if(dec!=='.')x=x.split(dec).join('.');return Number(x.replace(/[^0-9.-]/g,''))||0};
 const money=n=>fmt.format(n),container=root.querySelector('[data-pu-final-offers]'),buy=root.querySelector('[data-pu-final-buy]'),promo=root.querySelector('[data-pu-final-promo]');
 let widget=null,offers=[],last='',scheduled=false,observer;
 const nativeBuy=()=>document.querySelector('button[id^="BuyButtons-ProductSubmitButton"]');
 const topPrice=()=>document.querySelector('product-price[data-product-id="'+root.dataset.productId+'"]');
 function updateTop(o){
  const priceRoot=topPrice();if(!priceRoot)return;
  const row=priceRoot.querySelector('[ref="priceContainer"]');if(!row)return;
  const price=row.querySelector('.price'),compare=row.querySelector('.compare-at-price');
  if(price&&num(price.textContent)!==o.price)price.textContent=money(o.price);
  if(compare){compare.hidden=!(o.compare>o.price);if(num(compare.textContent)!==o.compare)compare.textContent=money(o.compare)}
  let badge=row.querySelector('.pu-canada-save-inline');
  if(!badge&&o.compare>o.price){badge=document.createElement('span');badge.className='pu-canada-save-inline';row.append(badge)}
  if(badge){badge.hidden=!(o.compare>o.price);badge.textContent='Save '+money(Math.max(0,o.compare-o.price))+' '+currency}
 }
 function read(){
  if(!widget||!widget.isConnected)widget=[...document.querySelectorAll('.bx-widget-container')].find(w=>!root.contains(w)&&w.querySelector('.js-bx-offer'));
  const nodes=widget?[...widget.querySelectorAll('.js-bx-offer')]:[];
  return nodes.map((node,i)=>({node,key:node.dataset.offerKey||String(i),name:node.querySelector('.bx-offer-title')?.textContent.trim()||'Offer '+(i+1),price:num(node.querySelector('.bx-offer-main .bx-discounted-price')?.textContent),compare:num(node.querySelector('.bx-offer-main .bx-original-price')?.textContent),selected:node.getAttribute('aria-checked')==='true'||node.classList.contains('bx-active')}));
 }
 function sync(){
  scheduled=false;offers=read();
  if(!offers.length){container.hidden=true;promo.hidden=true;const fallback=root.dataset.buttonLabel+' — '+money(Number(root.dataset.price));if(buy.textContent!==fallback)buy.textContent=fallback;return}
  container.hidden=false;
  const state=JSON.stringify(offers.map(o=>({key:o.key,name:o.name,price:o.price,compare:o.compare,selected:o.selected})));
  const active=offers.find(o=>o.selected)||offers[0];
  if(state!==last){
   last=state;container.replaceChildren();
   offers.forEach(o=>{
    const b=document.createElement('button');b.type='button';b.className='pu-minimal-final__offer';b.dataset.offerKey=o.key;b.setAttribute('aria-pressed',String(o.key===active.key));
    const title=document.createElement('span');title.className='pu-minimal-final__offer-name';title.textContent=o.name;b.append(title);
    const price=document.createElement('span');price.className='pu-minimal-final__offer-price';price.textContent=money(o.price);b.append(price);
    if(o.compare>o.price){const del=document.createElement('del');del.textContent=money(o.compare);b.append(del);const save=document.createElement('span');save.className='pu-minimal-final__offer-save';save.textContent='Save '+money(o.compare-o.price)+' '+currency;b.append(save)}
    b.addEventListener('click',()=>{o.node.click();queue()});container.append(b)
   });
   const max=Math.max(...offers.map(o=>o.compare>o.price?Math.round((o.compare-o.price)/o.compare*100):0));
   promo.hidden=!max;promo.textContent=max?'Save up to '+max+'%':'';
  }
  updateTop(active);
  const needsOptions=!!active.node.querySelector('select');
  buy.textContent=(needsOptions?'Choose options':root.dataset.buttonLabel)+' — '+money(active.price)+' '+currency;
  buy.disabled=!!nativeBuy()?.disabled;
 }
 function queue(){if(scheduled)return;scheduled=true;requestAnimationFrame(sync)}
 function connect(){
  sync();
  if(!widget)return false;
  observer=new MutationObserver(queue);observer.observe(widget,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['aria-checked','class']});
  widget.addEventListener('change',queue);widget.addEventListener('click',queue);
  return true;
 }
 buy.addEventListener('click',()=>{
  const active=offers.find(o=>o.node.getAttribute('aria-checked')==='true'||o.node.classList.contains('bx-active'))||offers[0];
  if(active?.node.querySelector('select')){widget.scrollIntoView({behavior:'smooth',block:'center'});active.node.querySelector('select')?.focus();return}
  const button=nativeBuy();if(button&&!button.disabled)button.click();else document.querySelector('#pumiii-product-buybox')?.scrollIntoView({behavior:'smooth',block:'center'});
 });
 if(!connect()){
  const ready=new MutationObserver(records=>{if(records.every(r=>root.contains(r.target)))return;if(connect())ready.disconnect()});ready.observe(document.querySelector('#MainContent')||document.body,{subtree:true,childList:true});
 }
 document.addEventListener('change',queue);
 document.addEventListener('shopify:section:load',queue);
}
document.querySelectorAll('[data-pu-dynamic-final]').forEach(init);
document.addEventListener('shopify:section:load',()=>document.querySelectorAll('[data-pu-dynamic-final]').forEach(init));
})();